<h2 mat-dialog-title>{{'Applicazione sconto' | translate}}</h2>
<mat-dialog-content class="discount-summary">
  @if (noDiscountApplied) {
    <div class="warning-box">
      {{'Il codice inserito non ha prodotto alcuno sconto su questa soluzione.' | translate}}
    </div>
  }
  @for (solution of solutions; track solution.title) {
    @if (solution.title) {
      <div class="solution-title">{{solution.title | translate}}</div>
    }
    @for (ticket of solution.tickets; track ticket) {
      <div class="ticket-row">
        <div>
          <div>{{ticket.travellerName}}</div>
          <div class="ticket-service">{{ticket.catalogServiceName}} · {{ticket.offerName}}</div>
        </div>
        <div>
          @if (ticket.discounted) {
            <span class="price-original">{{ticket.fullPrice | currency:'EUR':'symbol':'1.2-2'}}</span>
            <span class="price-discounted">{{ticket.discountedPrice | currency:'EUR':'symbol':'1.2-2'}}</span>
            <span class="discount-badge">{{'Scontato' | translate}}</span>
          } @else {
            <span>{{ticket.discountedPrice | currency:'EUR':'symbol':'1.2-2'}}</span>
          }
        </div>
      </div>
    }
  }
  <div class="totals">
    <span>{{'Totale' | translate}}</span>
    <span>
      @if (previousTotal && previousTotal !== newTotal) {
        <span class="price-original">{{previousTotal | currency:'EUR':'symbol':'1.2-2'}}</span>
      }
      <span>{{newTotal | currency:'EUR':'symbol':'1.2-2'}}</span>
    </span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{'Annulla' | translate}}</button>
  <button mat-raised-button color="primary" (click)="confirm()">{{'Procedi' | translate}}</button>
</mat-dialog-actions>
